
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { getAboutUs } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
info: {}, //关于我们内容
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
},
methods:{
...mapMutations(['SETTOKEN']),
getData(){
var that = this
this.$Loading()
getAboutUs({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.info = res.data[0]
console.log(that.info)
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/financialRule.vue